import { z } from 'zod';
import { FormDataResponse } from '../../../../model/sprievodnyDokument/FormDataResponse';
import { ObalMaterialuNrSr } from '../../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuNrSr';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import getObalMaterialuFormData from '../../../../function/getObalMaterialuFormData';
import Uuid from '../../../../model/Uuid';
import fallback from '../../../../function/zodFallback';

const ObalMaterialuNrSrResponse = z.object({
  rezortneCislo: fallback(z.string(), ''),
  cisloParlamentnejTlace: fallback(z.string(), ''),
  vladnyNavrh: fallback(z.string(), ''),
  typMaterialu: fallback(z.string(), ''),
  nazovMaterialu: fallback(z.string(), ''),
  navrhUznesenia: fallback(z.string(), ''),
  predkladatel: fallback(z.string(), ''),
  miestoDatum: fallback(z.string(), ''),
});

export function mapObalMaterialuNrSr(rawData: string): ObalMaterialuNrSr {
  const response = ObalMaterialuNrSrResponse.parse(rawData);

  return {
    rezortneCislo: response.rezortneCislo,
    cisloParlamentnejTlace: response.cisloParlamentnejTlace,
    vladnyNavrh: response.vladnyNavrh,
    typMaterialu: response.typMaterialu,
    nazovMaterialu: response.nazovMaterialu,
    navrhUznesenia: response.navrhUznesenia,
    predkladatel: response.predkladatel,
    miestoDatum: response.miestoDatum,
  };
}

interface Response {
  responseData: FormDataResponse<ObalMaterialuNrSr>,
  status: ClientStatus,
}

export default (
  type: string,
  year: number,
  index: number,
  sprievodnyDokumentUuid: Uuid,
): Response => {
  const {
    data,
    status,
  } = useClientFetch(
    getObalMaterialuFormData,
    [type, year, index, sprievodnyDokumentUuid],
    [],
  );

  return {
    responseData: data ? {
      formData: mapObalMaterialuNrSr(data.formData.formData),
      materialDetail: data.materialDetail,
    } : null,
    status,
  };
};
